import { Injectable } from '@angular/core';
import { CommonFunction } from '../helpers/commonFunction';

@Injectable({
  providedIn: 'root'
})
export class UserDetailService {

  constructor(private commonFunction: CommonFunction) { }

  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources  = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData  = resources.filter(function(item) {
      return item.Menu === 'UPSI Detail All';
      // return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
   if(resourcesData){
    upsiAdmin  = (resourcesData['Menu'])?true:false
   }else{
    upsiAdmin  = false
   }
   var decrEmailId=this.commonFunction.decrypt(user.EmailId);
    var loginUser = {
        id:user._id,
        firstName:user.FirstName,
        lastName:user.LastName,
        upsiAdmin:upsiAdmin,
        // EmailId:user.EmailId,
        EmailId:decrEmailId,
        companyDetails:companyDetails,
        title: user.Title
    }
    return JSON.stringify(loginUser);
  }

  getUserID() {
    var user = JSON.parse(localStorage.getItem("user"))
    return (user._id);
  }

  pssDetail() {
    var companyDetails = localStorage.getItem("companyDetails");
    //var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    //console.log("companyDetails11"+companyDetails);
    return companyDetails;
  }
  
  govevaDetail() {
    var companyDetails = localStorage.getItem("companyDetailsGoveva");
    //var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    //console.log("companyDetails11"+companyDetails);
    return companyDetails;
  }
}
